import { render, staticRenderFns } from "./ImageColorPalette.vue?vue&type=template&id=218da9c1&scoped=true&"
import script from "./ImageColorPalette.vue?vue&type=script&lang=ts&"
export * from "./ImageColorPalette.vue?vue&type=script&lang=ts&"
import style0 from "./ImageColorPalette.vue?vue&type=style&index=0&id=218da9c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218da9c1",
  null
  
)

export default component.exports